<template>
  <el-dialog
    title="Save Task"
    :visible.sync="show"
    @close="resetModal"
    :close-on-click-modal="false"
  >
    <el-form>
      <el-form-item label="Name">
        <el-input
          v-model="$v.name.$model"
          :class="{ error: checkValid && $v.name.$invalid }"
          @keyup.enter.native="handleSubmit"
        />
      </el-form-item>
      <el-form-item label="Description (Optional)">
        <el-input v-model="description" type="textarea" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="button" @click="handleSubmit">Save</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { required } from "vuelidate/lib/validators";

/**
 * @vue-data {Object} [name=null] - Name of the new task
 * @vue-data {Object} [description=null] - Description of the new task
 * @vue-data {Boolean} [checkValid=false] - Flag that indicates whether to check for errors
 */
export default {
  data() {
    return {
      name: null,
      description: null,
      checkValid: false,
      show: this.isVisible,
    };
  },
  watch: {
    isVisible(value) {
      this.show = value;
    },
  },
  props: {
    isVisible: Boolean,
  },
  methods: {
    /**
     * Resets the modal
     * @function
     */
    resetModal() {
      this.name = null;
      this.description = null;
      this.checkValid = false;
      this.$emit("update:isVisible", false);
    },
    /**
     * Submits the new task information
     * @function
     */
    handleSubmit() {
      this.checkValid = true;
      if (this.$v.name.$invalid) {
        return;
      }
      this.checkValid = false;

      this.$emit("taskSubmitted", {
        name: this.name,
        description: this.description,
      });
      this.$emit("update:isVisible", false);
    },
  },
  validations() {
    return {
      name: { required },
    };
  },
};
</script>

<style scoped>
.error :deep(.el-input__inner) {
  border: 1px solid red;
  border-radius: 4px;
}
.button {
  background-color: #b3282d;
  color: white;
  border-color: white;
}
.button:focus {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.button:hover {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.cancel-button {
  background-color: #7a7c80;
  color: white;
  border-color: white;
}
.cancel-button:focus {
  background-color: #606266;
  color: white;
  border-color: white;
  outline: none;
}
.cancel-button:hover {
  background-color: #606266;
  color: white;
  border-color: white;
  outline: none;
}
.el-textarea :deep(.el-textarea__inner) {
  resize: none;
  height: 125px !important;
  min-height: 125px !important;
}
</style>
